module.exports = __webpack_public_path__ + "2ff194a3715090105cf6660daee2aeb9.svg";